import React from 'react';
import { ArrowRightIcon, SparklesIcon, RocketIcon, UsersIcon, GlobeIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export const About = () => {
  const navigate = useNavigate();
  return <div className="min-h-screen bg-white" data-id="element-416">
      {/* Hero Section */}
      <div className="bg-gradient-to-br from-indigo-50 to-white" data-id="element-417">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24" data-id="element-418">
          <div className="text-center" data-id="element-419">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-420">
              Transform Your AI Ideas into{' '}
              <span className="bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent" data-id="element-421">
                Reality
              </span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto" data-id="element-422">
              RealUseAI is the leading platform for creating, sharing, and
              discovering practical AI applications. Turn your prompts into
              powerful tools that solve real problems.
            </p>
            <button onClick={() => navigate('/create')} className="bg-indigo-600 text-white px-8 py-3 rounded-lg text-lg font-medium hover:bg-indigo-700 transition-colors inline-flex items-center" data-id="element-423">
              Start Building <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-424" />
            </button>
          </div>
        </div>
      </div>
      {/* Stats Section */}
      <div className="bg-white py-16" data-id="element-425">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-426">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-427">
            <div className="text-center" data-id="element-428">
              <div className="text-3xl font-bold text-indigo-600 mb-2" data-id="element-429">
                100K+
              </div>
              <div className="text-gray-600" data-id="element-430">Active Users</div>
            </div>
            <div className="text-center" data-id="element-431">
              <div className="text-3xl font-bold text-indigo-600 mb-2" data-id="element-432">
                50K+
              </div>
              <div className="text-gray-600" data-id="element-433">AI Apps Created</div>
            </div>
            <div className="text-center" data-id="element-434">
              <div className="text-3xl font-bold text-indigo-600 mb-2" data-id="element-435">1M+</div>
              <div className="text-gray-600" data-id="element-436">Monthly Executions</div>
            </div>
            <div className="text-center" data-id="element-437">
              <div className="text-3xl font-bold text-indigo-600 mb-2" data-id="element-438">4.8</div>
              <div className="text-gray-600" data-id="element-439">Average Rating</div>
            </div>
          </div>
        </div>
      </div>
      {/* Features Section */}
      <div className="bg-gray-50 py-24" data-id="element-440">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-441">
          <h2 className="text-3xl font-bold text-center mb-16" data-id="element-442">
            Why Choose RealUseAI
          </h2>
          <div className="grid md:grid-cols-3 gap-12" data-id="element-443">
            <div className="text-center" data-id="element-444">
              <div className="bg-indigo-100 w-16 h-16 rounded-xl flex items-center justify-center mx-auto mb-6" data-id="element-445">
                <SparklesIcon className="h-8 w-8 text-indigo-600" data-id="element-446" />
              </div>
              <h3 className="text-xl font-semibold mb-4" data-id="element-447">Easy to Use</h3>
              <p className="text-gray-600" data-id="element-448">
                Create AI apps in minutes with our intuitive interface. No
                coding required.
              </p>
            </div>
            <div className="text-center" data-id="element-449">
              <div className="bg-indigo-100 w-16 h-16 rounded-xl flex items-center justify-center mx-auto mb-6" data-id="element-450">
                <RocketIcon className="h-8 w-8 text-indigo-600" data-id="element-451" />
              </div>
              <h3 className="text-xl font-semibold mb-4" data-id="element-452">Powerful Features</h3>
              <p className="text-gray-600" data-id="element-453">
                Access cutting-edge AI models and customize them to your needs.
              </p>
            </div>
            <div className="text-center" data-id="element-454">
              <div className="bg-indigo-100 w-16 h-16 rounded-xl flex items-center justify-center mx-auto mb-6" data-id="element-455">
                <GlobeIcon className="h-8 w-8 text-indigo-600" data-id="element-456" />
              </div>
              <h3 className="text-xl font-semibold mb-4" data-id="element-457">Global Community</h3>
              <p className="text-gray-600" data-id="element-458">
                Share your apps with millions of users or keep them private.
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* How It Works */}
      <div className="bg-white py-24" data-id="element-459">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-460">
          <h2 className="text-3xl font-bold text-center mb-16" data-id="element-461">How It Works</h2>
          <div className="grid md:grid-cols-4 gap-8" data-id="element-462">
            <div className="text-center" data-id="element-463">
              <div className="text-2xl font-bold text-indigo-600 mb-4" data-id="element-464">1</div>
              <h3 className="font-semibold mb-2" data-id="element-465">Choose Your Template</h3>
              <p className="text-gray-600 text-sm" data-id="element-466">
                Start with a pre-built template or create from scratch
              </p>
            </div>
            <div className="text-center" data-id="element-467">
              <div className="text-2xl font-bold text-indigo-600 mb-4" data-id="element-468">2</div>
              <h3 className="font-semibold mb-2" data-id="element-469">Customize Your App</h3>
              <p className="text-gray-600 text-sm" data-id="element-470">
                Configure AI models and add your own prompts
              </p>
            </div>
            <div className="text-center" data-id="element-471">
              <div className="text-2xl font-bold text-indigo-600 mb-4" data-id="element-472">3</div>
              <h3 className="font-semibold mb-2" data-id="element-473">Test and Refine</h3>
              <p className="text-gray-600 text-sm" data-id="element-474">
                Preview your app and make it perfect
              </p>
            </div>
            <div className="text-center" data-id="element-475">
              <div className="text-2xl font-bold text-indigo-600 mb-4" data-id="element-476">4</div>
              <h3 className="font-semibold mb-2" data-id="element-477">Share with the World</h3>
              <p className="text-gray-600 text-sm" data-id="element-478">
                Publish your app to the marketplace
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* CTA Section */}
      <div className="bg-indigo-600 py-16" data-id="element-479">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-480">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-481">
            Ready to Start Building?
          </h2>
          <p className="text-indigo-100 mb-8 max-w-2xl mx-auto" data-id="element-482">
            Join thousands of creators who are building the future with AI.
          </p>
          <button onClick={() => navigate('/create')} className="bg-white text-indigo-600 px-8 py-3 rounded-lg text-lg font-medium hover:bg-indigo-50 transition-colors" data-id="element-483">
            Create Your First App
          </button>
        </div>
      </div>
    </div>;
};